import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as foldersReducer from "containers/Folders/reducer";

import { getProjectID, getProjectDatasets, getCreatingProject } from "containers/ConsultingProjects/reducer";
import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";

import DatasetLink from "components/View/DatasetLink";

class DatasetLinkContainer extends React.Component {
  handleFile(event) {
    const { handleFileChange, validateFileExtension, updateIsLinkMode } = this.props;

    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    if (validateFileExtension(file)) {
      updateIsLinkMode(false);
      return handleFileChange(file, event.currentTarget);
    }
  }

  render() {
    return <DatasetLink handleFileUpload={(e) => this.handleFile(e)} {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  validateFileExtension: (file, extension) => uploadReducer.validateFileExtension(file, extension),
  handleFileChange: (file, target) => dispatch(uploadReducer.handleFileChange(file, target)),
  updateIsLinkMode: (isLinkMode) => dispatch(viewReducer.updateIsLinkMode(isLinkMode)),
  linkDataset: (settings) => dispatch(homeReducer.linkDataset(settings)),
  addMockCatalog: () => dispatch(homeReducer.addMockCatalog())
});

const mapStateToProps = (state, ownProps) => {
  const accounts = accountsReducer.getAccounts(state);
  const selectedFolder = foldersReducer.getSelectedFolder(state);

  return {
    data:
      (getIsMarketplaceDemo() &&
        getProjectID(state) !== null &&
        getCreatingProject(state) &&
        getProjectDatasets(state)) ||
      viewReducer.getDatasets(state, ownProps.blueprintId),
    isLinkMode: viewReducer.getIsLinkMode(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DatasetLinkContainer);
